import React from 'react';
import { Reveal } from '../Reveal';
export function Reflection() {
  return <section className="w-full px-5 py-12 sm:py-16" data-id="element-222" data-mp="33ymcykvz66sz">
      <div className="mx-auto max-w-2xl text-center" data-id="element-223" data-mp="33xupxygg1heb">
        <Reveal data-id="element-224" data-mp="2zwrc1hhyhvfq">
          <h2 className="font-display text-2xl leading-tight text-snow sm:text-4xl" data-id="element-225" data-mp="2zw99k34pakzd">
            Lo que realmente cambia <span className="u-lime" data-id="element-226" data-mp="2uyzlaqt1sfd4">no es solamente tu planificación</span>
          </h2>
        </Reveal>

        <Reveal delay={80} className="mt-8" data-id="element-227" data-mp="3rmx8r9mtdgae">
          <p className="text-sm text-snow-muted sm:text-base" data-id="element-228" data-mp="3rq1nh0xwnufb">Es dejar de preguntarte cada semana:</p>
          <p className="mt-2 font-display text-2xl italic text-snow-dim line-through decoration-1 sm:text-3xl" data-id="element-229" data-mp="3ivwzcpa5ox3h">
            “¿Qué hago mañana?”
          </p>
          <p className="mt-6 text-sm text-snow-muted sm:text-base" data-id="element-230" data-mp="3dwalqeqf1eu5">Y empezar a preguntarte:</p>
          <p className="mt-2 font-display text-2xl italic text-lime sm:text-4xl" data-id="element-231" data-mp="f7limv643g5t">“¿Qué quiero trabajar mañana?”</p>
        </Reveal>

        <Reveal delay={140} className="mt-8" data-id="element-232" data-mp="ae8v6od65fen">
          <p className="mx-auto max-w-lg text-sm leading-relaxed text-snow sm:text-base" data-id="element-233" data-mp="uccezsvkzysx">
            Porque ahora no necesitás inventar todo nuevamente. Elegís una propuesta, la adaptás a tus alumnas y te
            enfocás en lo verdaderamente importante:
          </p>
          <p className="mt-5 font-display text-4xl tracking-wide text-snow sm:text-5xl" data-id="element-234" data-mp="plnke4olulpk">ENSEÑAR.</p>
        </Reveal>
      </div>
    </section>;
}